import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router/composables';

import {
  ContextColorProvider,
  NavBar,
  SpinnerLoader,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { CustomOperationDetailsContent } from './components/CustomOperationDetailsContent';

import {
  getCustomOperationDetails,
  CustomOperation
} from '@/modules/trade/services/custom-operations';
import { isBFFError } from '@/modules/common/helpers/bff';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomOperationDetailsView',
  setup(__props) {

const isLoading = ref<boolean>(true);
const hasError = ref<boolean>(false);
const errorMessage = ref<string>(
  'Não foi possível carregar a operação personalizada'
);
const customOperationData = ref<CustomOperation>({} as CustomOperation);

const route = useRoute();

const customOperationId = computed(() => {
  const { id } = route.params;

  return id;
});

onMounted(() => {
  fetchCustomOperationData();
});

const fetchCustomOperationData = async () => {
  try {
    isLoading.value = true;
    hasError.value = false;

    const response = await getCustomOperationDetails(customOperationId.value);

    customOperationData.value = response;
  } catch (e) {
    let message = 'Não foi possível carregar a operação personalizada';
    hasError.value = true;

    if (isBFFError(e)) {
      message = e.error.message.formatted;
    }

    errorMessage.value = message;
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,isLoading, hasError, errorMessage, customOperationData, route, customOperationId, fetchCustomOperationData, ContextColorProvider, NavBar, SpinnerLoader, HelperViewStatus, BackButton, CustomOperationDetailsContent }
}

})